import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "components/FormField";
import { AgeCalculation } from "utils/functions";

const CooperatedFormCollaborator = ({ label, cooperated, setInput }) => {
  const [step, setStep] = useState(true);

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox sx={{ marginY: 2 }}>
              <MDTypography sx={{ fontSize: 13 }}>
                Tipo de Contratação
              </MDTypography>
              <RadioGroup
                row
                name="hiring_type"
                value={cooperated?.hiring_type}
                onChange={setInput}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio />}
                  label="Empregado Fixo"
                />
                <FormControlLabel
                  value={3}
                  control={<Radio />}
                  label="Estagiário"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio />}
                  label="Jovem Aprendiz"
                />
              </RadioGroup>
            </MDBox>

            <MDBox mt={1.625}>
              <FormField
                type="text"
                label="Nome completo"
                name="full_name"
                value={cooperated?.full_name}
                placeholder="Nome completo"
                onChange={setInput}
                required
              />

              <FormField
                type="text"
                label="Nome social"
                name="social_name"
                value={cooperated?.social_name}
                placeholder="Nome social"
                onChange={setInput}
              />

              <FormField
                type="email"
                label="E-mail"
                name="email"
                value={cooperated?.email}
                placeholder="E-mail"
                onChange={setInput}
                required
              />

              <FormField
                type="text"
                label="CPF"
                name="cpf"
                value={cooperated?.cpf}
                placeholder="CPF"
                mask="CPF"
                onChange={setInput}
                required
              />

              <FormField
                type="text"
                label="Data de Nascimento"
                name="birth_date"
                value={cooperated?.birth_date}
                mask="date"
                placeholder="Data de Nascimento"
                onChange={setInput}
                required
              />

              {cooperated?.birth_date &&
                cooperated?.birth_date.length === 10 &&
                AgeCalculation(
                  cooperated?.birth_date,
                  cooperated?.hiring_type
                ) && (
                  <FormField
                    type="email"
                    label="E-mail do Responsável Legal"
                    name="responsible_email"
                    value={cooperated?.responsible_email}
                    placeholder="E-mail do Responsável Legal"
                    required={AgeCalculation(
                      cooperated?.birth_date,
                      cooperated?.hiring_type
                    )}
                    onChange={setInput}
                  />
                )}
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormCollaborator;
